
import FormElement
    from "./FormElement";
import dayjs
    from "dayjs";
import customerParseFormat from "dayjs/plugin/customParseFormat";
import {
    TextField
} from "@mui/material";
import {useTheme} from '@mui/material/styles';
import {TimePicker} from "@mui/x-date-pickers-pro";
dayjs.extend(customerParseFormat);

const FormTextField = ({
                           template,
                           values,
                           defaultAnswer,
                           onChange,
                           onBlur,
                           disabled = false,
                           defaultAnswers,
                           ...rest
                       }) => {
    const {hiddenLabel} = useTheme();

    const {
        id,
        content,
        name,
    } = template;

    const {
        casing,
        lookupTable, // @TODO
        lookupSettings, // @TODO
        lookupSettingsFilter, // @TODO
        lookupDisplay, // @TODO
        userVariable, // @TODO
        question,
        multiline,
        autoDefault,
        choiceType,
        defaultText, // deprecated
        stringFormat, // deprecated
        maxLength,
        parseText, // deprecated
        ignoreIfHidden,
    } = content;

    const className = `fz-form-field-text ${choiceType !== 'text' ? `fz-form-field-${choiceType}` : ''}`;
    const {value: submissionValue} = values;
    let value = '';

    if (submissionValue?.text) {
        value = submissionValue.text;
    } else if (defaultAnswer?.text) {
        value = defaultAnswer?.text;
    }

    let type = choiceType;

    switch (choiceType) {
        case 'currency':
        case 'number':
            type = 'text';
            break;
        case 'location':
            type = 'text';
            break;
        case 'date':
            value = dayjs(value).format("YYYY-MM-DD");
            break;
        case 'time':
            value = value ? dayjs(value, "H:mm") : null;
            break;
    }

    const otherProps = {
        required: (values.required === 1 || values.required === '1' || values.required === true || values.required === 'true'),
        ...rest
    };

    const inputProps = {
        required: values.required,
    };

    if (disabled === true) {
        otherProps.disabled = true;
    }

    if (maxLength) {
        inputProps.maxLength = maxLength;
    }

    if (multiline) {
        otherProps.rows = 5;
        otherProps.multiline = true;
    }

    if (hiddenLabel) {
        otherProps.label = question;
    }

    if (choiceType === 'number' || choiceType === 'currency') {
        inputProps.pattern = `^[+-]?(\d+|\d*\.\d+)([eE][+-]?\d+)?$`;
        otherProps.onKeyPress = (event) => {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);

            // Allow numeric characters, plus/minus signs, decimal point, and "e" character
            const validKeys = /[0-9+-e.]/;

            if (!validKeys.test(keyValue)) {
                event.preventDefault();
            }
        };
    }

    /**
     * Generate the value payload to match the submission JSON format
     *
     * @param value
     * @returns {{text}}
     */
    const generateValue = (value) => {
        let finalValue = value;

        switch (choiceType) {
            case 'date':
                finalValue = dayjs(value).format("DD MMM YYYY");
                break;
            case 'time':
                finalValue = dayjs(value).format("H:mm");
                break;
        }

        return {
            text: finalValue
        }
    }

    const Element = choiceType === 'time' ? TimePicker : TextField;

    return (
        <FormElement id={id} label={question} hiddenLabel={hiddenLabel} className="fz-form-element-text" required={otherProps.required}>
            <Element type={type}
                       onChange={event => {
                           if (choiceType === 'time') {
                               onChange(generateValue(event));
                               return;
                           }

                           let value = event.target.value;

                           if (casing === 'upper') {
                               value = value.toUpperCase();
                           } else if (casing === 'lower') {
                               value = value.toLowerCase();
                           }

                           onChange(generateValue(value))
                       }}
                       onBlur={onBlur}
                       id={id}
                       className={className}
                       value={value}
                       autoComplete="off"
                       fullWidth
                       name={name}
                       inputProps={inputProps}
                       {...otherProps}/>
        </FormElement>
    )
}

export default FormTextField;